import React from "react";
import { Link } from "react-router-dom";

import banner1 from "assets/img/banner1.jpg";
import banner2 from "assets/img/banner2.jpg";
import logo from "assets/img/now-logo.png";
import SponsorMarquee from "components/Sponsors/SponsorMarquee";
import TimetableModal from "components/Schedule/TimetableModal";
import { VENUE_MAP_URL } from "utils/venue";

const banners = [banner1, banner2];

function IndexHeader() {
  const heroBg = React.useRef(null);
  const [active, setActive] = React.useState(0);
  const [timetableOpen, setTimetableOpen] = React.useState(false);

  React.useEffect(() => {
    const id = setInterval(() => {
      setActive((i) => (i + 1) % banners.length);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        if (!heroBg.current) return;
        const offset = window.pageYOffset / 4;
        heroBg.current.style.transform =
          "scale(1.05) translate3d(0," + offset + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return () => window.removeEventListener("scroll", updateScroll);
    }
  }, []);

  return (
    <header className="hm-hero">
      <div className="hm-hero-bg" ref={heroBg}>
        {banners.map((src, i) => (
          <div
            key={i}
            className={"hm-hero-slide" + (i === active ? " is-active" : "")}
            style={{ backgroundImage: "url(" + src + ")" }}
          ></div>
        ))}
      </div>
      <div className="hm-hero-scrim"></div>
      <div className="hm-hero-inner">
        <img className="hm-hero-logo" src={logo} alt="SORRBA logo" />
        <h1>SORRBA</h1>
        <div className="hm-hero-sub">Durgotsav 2026</div>
        <p className="hm-hero-years">
          Celebrating <b>18 years</b> of togetherness
        </p>
        <div className="hm-hero-cta">
          <a
            className="hm-btn hm-btn-primary"
            href={VENUE_MAP_URL}
            target="_blank"
            rel="noreferrer"
          >
            <i className="now-ui-icons location_pin" /> Durga Puja Venue
          </a>
          <Link className="hm-btn hm-btn-ghost" to="/membership">
            New / Renew Membership
          </Link>
          <button
            className="hm-btn hm-btn-ghost"
            type="button"
            onClick={() => setTimetableOpen(true)}
          >
            <i className="now-ui-icons ui-1_calendar-60" /> Puja time table
          </button>
        </div>
      </div>
      <SponsorMarquee />
      <TimetableModal isOpen={timetableOpen} onClose={() => setTimetableOpen(false)} />
    </header>
  );
}

export default IndexHeader;
